export const defaultSortIconClass = 'fa fa-sort';
export const ascSortIconClass = 'fa fa-sort-up';
export const descSortIconClass = 'fa fa-sort-down';

export const collectSortObject = (sorts, sortBy) => {
    const sortsObject = JSON.parse(JSON.stringify(sorts));
    let sortOrder = 'asc';

    Object.keys(sortsObject).forEach((key) => {
        if (key === sortBy) {
            if (sortsObject[key].order === 'asc') {
                sortOrder = 'desc';
                sortsObject[key].order = 'desc';
                sortsObject[key].icon = descSortIconClass;
            } else {
                sortOrder = 'asc';
                sortsObject[key].order = 'asc';
                sortsObject[key].icon = ascSortIconClass;
            }
        } else {
            sortsObject[key].order = null;
            sortsObject[key].icon = defaultSortIconClass;
        }
    });

    return { sortOrder, sortsObject };
};
